import React, { useId } from "react";

import { useController, useFormContext } from "react-hook-form";

import { Checkbox } from "@/src/components/ui/checkbox";
import { Field, FieldLabel } from "@/src/components/ui/field";

import type { JSX } from "react";
import type { FieldPathByValue, FieldValues } from "react-hook-form";

interface CheckboxFieldBaseProps {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function CheckboxFieldBase({
  label,
  checked,
  disabled,
  onCheckedChange,
}: CheckboxFieldBaseProps): JSX.Element {
  const id = useId();

  return (
    <Field orientation="horizontal">
      <Checkbox
        checked={checked}
        disabled={disabled}
        id={id}
        onCheckedChange={(state) => onCheckedChange(state === true)}
      />
      <FieldLabel htmlFor={id}>{label}</FieldLabel>
    </Field>
  );
}

interface CheckboxFieldProps<T extends FieldValues> {
  name: FieldPathByValue<T, boolean | undefined>;
  label: string;
}

export function CheckboxField<T extends FieldValues>({
  name,
  label,
}: CheckboxFieldProps<T>): JSX.Element {
  const { control } = useFormContext();
  const { field } = useController({ control, name });

  return (
    <CheckboxFieldBase
      checked={field.value ?? false}
      label={label}
      onCheckedChange={field.onChange}
    />
  );
}
